import { render, staticRenderFns } from "./CourseCourseCertificateMiniItem.vue?vue&type=template&id=2373ca2d&scoped=true"
import script from "./CourseCourseCertificateMiniItem.vue?vue&type=script&lang=js"
export * from "./CourseCourseCertificateMiniItem.vue?vue&type=script&lang=js"
import style0 from "./CourseCourseCertificateMiniItem.vue?vue&type=style&index=0&id=2373ca2d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2373ca2d",
  null
  
)

export default component.exports